import type { Product } from './product'
import { productGraphQlFragment } from './product'

export interface Menu {
  id: string
  name: string
  items: {
    id: string
    resourceId: string
    title: string
    url: string
    resource: {
      image?: {
        url: string
      }
      handle: string
    }
  }[]
}

export interface CategoryResponse {
  data: {
    menu: Menu
  }
}

export interface CollectionResponse {
  data: {
    collection: Collection
  }
}

export interface Collection {
  id: string
  title: string
  handle: string
  image: {
    url: string
  }
  products: {
    edges: {
      node: Product
    }[]
  }
}

export async function loadCategories(): Promise<CategoryResponse> {
  const res = await fetch(
    `https://${import.meta.env.VITE_SHOPIFY_STORE}.myshopify.com/api/2022-10/graphql.json`,
    {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': import.meta.env
          .VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `query categories($handle: String!) {
          menu(handle: $handle) {
            id,
            items {
              id,
              resourceId,
              title,
              url
              resource {
                ... on Collection {
                  image {
                    url
                  }
                  handle
                }
              }
            }
          }
        }`,
        variables: {
          handle: 'customer-portal-category-nav',
        },
      }),
    },
  )
  return await res.json()
}

export async function loadCollection(
  handle: string,
): Promise<CollectionResponse> {
  const res = await fetch(
    `https://${import.meta.env.VITE_SHOPIFY_STORE}.myshopify.com/api/2022-10/graphql.json`,
    {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': import.meta.env
          .VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `query collection($handle: String!) {
          collection(handle: $handle) {
            id,
            title,
            handle,
            image {
              url
            }
            products(first: 250) {
              edges {
                node {
                  ${productGraphQlFragment}
                }
              }
            }
          }
        }`,
        variables: {
          handle,
        },
      }),
    },
  )
  return await res.json()
}
